namespace GeniuzPOS.Purchase {
    export interface ReportDailyCNData extends Serenity.ListRequest {
        para?: string;
        Shop?: string;
        DatetoDate?: string;
        Supdata?: string;
        ListHd?: ReportDailyCNRow[];
    }
}
